'use strict';/* global define, console */define('modules/feedback/services/feedback-wizard-state-machine/index',['require','exports','module'],function(require,exports,module){'use strict';// @ngInject
factory.$inject = ["$state", "$rootScope", "$document", "$injector", "$q", "_", "AnimatedScrollTo"];
function factory($state,$rootScope,$document,$injector,$q,_,AnimatedScrollTo){// jshint validthis:true
// jshint latedef:false
/**
     * Initialize a new StateMachine
     *
     * @param {Object} config - config object
     *
     * @constructor
     *
     * @tested
     */var StateMachine=function StateMachine(config){this.baseState=config.baseState;this.preState=config.preState;this.finalState=config.finalState;var baseStateRegex=new RegExp(this.baseState);this.states=config.states||[];if(config.containerId){this.container=$document[0].getElementById(config.containerId);}if($state.$current.name===config.baseState){if(config.entryState&&config.entryState.match(/(\w+?\.\w+?\.\w+?\.\w+?\.).*$/)[1]===config.baseState.match(/(\w+?\.\w+?\.\w+?\.\w+?\.).*$/)[1]){this.index=_getStateIndex(this.states,{name:config.entryState});$state.go(config.entryState);}else{this.enter();}}else{this.index=_getStateIndex(this.states,{name:$state.$current.name});}this.destroy=$rootScope.$on('$stateChangeSuccess',function(event,stateTo){if(baseStateRegex.test(stateTo.name)){var index=_getStateIndex(this.states,stateTo);if(config.onProgress&&index>this.index){config.onProgress(stateTo);}if(~index){this.index=index;}if(stateTo.name===config.baseState){this.enter();}}if(config.onProgress&&stateTo.name===config.finalState){config.onProgress(stateTo);}}.bind(this));};/**
     * Enter the initial state included and configured
     * in the state machine
     *
     * @tested
     */StateMachine.prototype.enter=function(){this.index=0;$state.go(this.states[this.index].name);};/**
     * Go to the next state included and configured
     * in the state machine
     *
     * if no next state is available navigation to `endState`
     * takes place
     *
     * @tested
     */StateMachine.prototype.goNext=function goNext(){if(this.states[this.index+1]){if(this.container&&this.container.getBoundingClientRect().top<+100){AnimatedScrollTo.scrollTo(this.container).then(function(){$state.go(this.states[this.index+1].name);}.bind(this));}else{$state.go(this.states[this.index+1].name);}}else{if(this.finalState){$state.go(this.finalState);}}};/**
     * Go to the prev state included and configured
     * in the state machine
     *
     * if no prev state is available navigation to `endState`
     * takes place
     *
     * @tested
     */StateMachine.prototype.goPrev=function goPrev(){if(this.states[this.index-1]){if(this.container&&this.container.getBoundingClientRect().top<-300){AnimatedScrollTo.scrollTo(this.container).then(function(){$state.go(this.states[this.index-1].name);}.bind(this));}else{$state.go(this.states[this.index-1].name);}}else{if(this.preState){$state.go(this.preState);}}};/**
     * Helper function to retrieve the index of a state
     * inside of a passed in collection
     *
     * @param  {Array}  states - states
     * @param  {Object} state  - state
     *
     * @return {Number}        - index
     */function _getStateIndex(states,currentState){return states.reduce(function(result,state,index){if(state.name===currentState.name){result=index;}return result;},-1);}return{init:init,getStatesForPeriod:getStatesForPeriod};// ---
function destry(){}/**
     * Get new state machine to handle the complete
     * feedback wizard flow
     *
     * Possible config options:
     *
     * ```
     * {
     *   states            : [ 'foo.bar', 'foo.bar', 'foo.bang' ]  // states to be included
     *   redirectInitially : true                                  // should initial redirect to first state happen
     *   preState          : 'init'                                // state to go to when hitting prev border
     *   baseState         : 'foo'                                 // state needed to react to "$stateChangeSuccess" event
     *   finalState        : 'final'                               // state to go to when hitting next border
     * }
     * ```
     *
     * @param  {Object} config - config
     *
     * @return {Object}        - new state machine object
     *
     * @tested
     */function init(config){return new StateMachine(config);}/**
     * Evaluate available states for a given base path
     *
     * -> it will get all the children and check if there
     * is a position assigned to it
     * -> it will check visibility by executing `isVisible` fn
     *
     * @param  {String} baseState - baseState of the feedback wizard
     * @param  {Object} period    - feedback period
     *
     * @return {Promise}          - promise to be resolved when all
     *                              all states are evaluated
     *
     * @tested
     */function getStatesForPeriod(baseState,period){var deferred=$q.defer();var baseStateRegex=new RegExp(baseState);var states=$state.get().filter(filterForWizardPosition).sort(sortByWizardPosition).map(mapStateToPromise);$q.allSettled(states).then(function(values){deferred.resolve(values.reduce(function(states,statePromise){if(statePromise.state==='fulfilled'){states.push(statePromise.value);}return states;},[]));});return deferred.promise;// -----
function filterForWizardPosition(state){return baseStateRegex.test(state.name)&&state.meta&&state.meta.wizardPosition;}function sortByWizardPosition(stateA,stateB){return stateA.meta.wizardPosition-stateB.meta.wizardPosition;}function mapStateToPromise(state){if(state.meta.isVisible===undefined){return state;}if(typeof state.meta.isVisible==='function'){var deferred=$q.defer();$injector.invoke(state.meta.isVisible)(period).then(function(){deferred.resolve(state);}).catch(deferred.reject);return deferred.promise;}return state;}}}module.exports=factory;});
